import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { InputEl } from "common/components/input";
import { SelectEl } from "common/components/select";
import { InputLabelEl } from "common/components/input/label";
import { SpinnerEl } from "common/components/spinner";
import { BannerEl } from "common/components/banner";
import { BannerType } from "common/components/banner/types";
import { Severity, SeverityLabels } from "./types";
export function template() {
  const t = this.getContext("i18n").t;
  return /* @__PURE__ */ jsx("div", { sel: ".support-widget-container", class: {
    maximized: this.state.isMaximized,
    minimized: this.state.isMinimized
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".support-widget" }, /* @__PURE__ */ jsx("header", { on: {
    click: (ev) => this.state.isMinimized ? this.helpers.toggleMinimize(ev, false) : null
  } }, /* @__PURE__ */ jsx("div", null, this.state.isTicketSubmitted ? t("help.support.submitted-title") : t("help.support.pending-title")), !(this.state.isMaximized || this.state.isMinimized) ? /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "dash"
  }, on: {
    click: (ev) => this.helpers.toggleMinimize(ev, true)
  } }) : null, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    elref: "toggleMaximizeButton",
    icon: this.state.isMaximized ? "collapse" : "expand"
  }, on: {
    click: this.helpers.toggleFullscreen
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" })), this.state.isTicketSubmitted ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".zendesk-ticket-submitted" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "circle-checkmark"
  } }), /* @__PURE__ */ jsx("div", { sel: ".thanks" }, t("help.support.thank-you")), /* @__PURE__ */ jsx("div", { sel: ".confirmation" }, t("help.support.thank-you-followup", {
    userEmail: this.attr("user-email")
  }))), /* @__PURE__ */ jsx("footer", { sel: ".buttons" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".done", attrs: {
    theme: ButtonTheme.Primary
  }, on: {
    click: this.helpers.closeSupportWidget
  } }, t("help.support.done")))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".new-zendesk-ticket" }, this.helpers.showSeverityDropdown() ? /* @__PURE__ */ jsx("div", { sel: ".form-field" }, /* @__PURE__ */ jsx(InputLabelEl, { attrs: {
    label: t("help.support.priority")
  } }), /* @__PURE__ */ jsx(SelectEl, { attrs: {
    elref: "severityField",
    sections: [{
      items: [{
        label: SeverityLabels[Severity.SEV_0],
        value: Severity.SEV_0
      }, {
        label: SeverityLabels[Severity.SEV_1],
        value: Severity.SEV_1
      }, {
        label: SeverityLabels[Severity.SEV_2],
        value: Severity.SEV_2
      }, {
        label: SeverityLabels[Severity.DEFAULT],
        value: Severity.DEFAULT
      }]
    }],
    "selected-option": SeverityLabels[this.state.severity],
    size: ButtonSize.Large
  }, on: {
    change: (ev) => this.helpers.selectSeverity(ev)
  } })) : null, /* @__PURE__ */ jsx("div", { sel: ".form-field" }, /* @__PURE__ */ jsx(InputLabelEl, { attrs: {
    label: t("help.support.request-type")
  } }), /* @__PURE__ */ jsx(SelectEl, { attrs: {
    elref: "requestType",
    sections: [{
      items: this.helpers.getRequestTypeOptions()
    }],
    "selected-option": t(this.state.requestTypeLabel) || t("help.support.request-type-prompt"),
    size: ButtonSize.Large
  }, on: {
    change: (ev) => this.helpers.selectRequestType(ev)
  } })), /* @__PURE__ */ jsx(null, null, this.helpers.showFreePlanWarning() ? /* @__PURE__ */ jsx(BannerEl, { sel: ".free-plan-warning-message", attrs: {
    type: BannerType.Embedded,
    theme: "info",
    "body-text": t("help.support.free-plan-warning")
  } }) : null, /* @__PURE__ */ jsx("div", { sel: ".remaining-form-fields", key: "form-fields", class: {
    hidden: this.helpers.showFreePlanWarning()
  } }, this.state.requestTypeLabel ? /* @__PURE__ */ jsx("div", { sel: ".form-field" }, /* @__PURE__ */ jsx(InputLabelEl, { attrs: {
    label: t(this.helpers.getRequestSubtypeTicketField())
  } }), /* @__PURE__ */ jsx(SelectEl, { attrs: {
    elref: "requestSubType",
    sections: [{
      items: this.helpers.getRequestSubtypeOptions()
    }],
    label: t(this.state.requestSubtypeLabel),
    "disable-search": true,
    "selected-option": this.state.requestSubtypeLabel || t("help.support.select-sub-type", {
      subType: t(this.helpers.getRequestSubtypeTicketField())
    }),
    size: ButtonSize.Large
  }, on: {
    change: (ev) => this.helpers.selectRequestSubtype(ev)
  } })) : null, /* @__PURE__ */ jsx("div", { sel: ".form-field" }, /* @__PURE__ */ jsx(InputEl, { attrs: {
    label: t("help.support.subject"),
    elref: "subjectField"
  }, on: {
    input: this.helpers.inputSubject
  }, props: {
    value: this.state.subject || ""
  } })), /* @__PURE__ */ jsx("div", { sel: ".form-field" }, /* @__PURE__ */ jsx(InputEl, { attrs: {
    type: "textarea",
    label: t("help.support.issue-prompt"),
    elref: "descriptionField"
  }, on: {
    input: this.helpers.handleInputComment,
    paste: this.helpers.handlePasteFromClipboard
  }, props: {
    value: this.state.comment || ""
  } })), /* @__PURE__ */ jsx("div", { sel: ".form-field" }, /* @__PURE__ */ jsx(InputLabelEl, { attrs: {
    label: this.state.uploads.length === 0 ? t("help.support.attachments") : "".concat(t("help.support.attachments"), " (").concat(this.state.uploads.length, ")"),
    necessary: "optional"
  } }), this.state.isUploadingFiles ? /* @__PURE__ */ jsx("div", { sel: ".uploading-file" }, /* @__PURE__ */ jsx(SpinnerEl, null, t("help.support.uploading"))) : null, /* @__PURE__ */ jsx("label", { sel: ".upload-files", attrs: {
    for: "upload-files"
  }, class: {
    active: this.state.isDraggingAndDropping,
    disabled: this.state.uploads.length === this.helpers.MAX_FILE_UPLOADS
  }, on: {
    dragleave: this.helpers.fileInputDragleave,
    dragover: (ev) => this.helpers.fileInputDragover(ev),
    drop: (ev) => this.helpers.uploadDroppedFiles(ev)
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "image"
  } }), /* @__PURE__ */ jsx("div", { sel: ".upload-files-text" }, (() => {
    const uploadsRemaining = this.helpers.MAX_FILE_UPLOADS - this.state.uploads.length;
    const numUploads = this.state.uploads.length;
    if (numUploads === 0) {
      return t("help.support.screenshots-none", {
        maxUploads: this.helpers.MAX_FILE_UPLOADS
      });
    } else if (numUploads < this.helpers.MAX_FILE_UPLOADS) {
      return t("help.support.screenshots-add", {
        count: uploadsRemaining
      });
    } else {
      return t("help.support.screenshots-limit-reached");
    }
  })())), /* @__PURE__ */ jsx("input", { sel: "#upload-files", attrs: {
    accept: "image/*",
    type: "file",
    multiple: true
  }, hook: {
    insert: (vnode) => this.helpers.setElRef("fileInput", vnode.elm)
  }, on: {
    input: this.helpers.uploadSelectedFiles
  } }), /* @__PURE__ */ jsx("p", null, t("help.support.need-help"), " ", /* @__PURE__ */ jsx("a", { attrs: {
    href: "https://docs.mixpanel.com/"
  }, on: {
    click: this.helpers.trackHelpDocs
  } }, t("help.support.visit-docs")), " ", t("help.support.docs-tip")))))), /* @__PURE__ */ jsx("footer", { sel: ".buttons" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".cancel-button", attrs: {
    elref: "cancelButton",
    theme: ButtonTheme.Tertiary
  }, on: {
    click: this.helpers.closeSupportWidget
  } }, t("help.support.cancel")), /* @__PURE__ */ jsx(ButtonEl, { sel: ".submit-button", attrs: {
    disabled: this.helpers.isSubmitDisabled(),
    theme: ButtonTheme.Primary
  }, on: {
    click: this.helpers.submitZendeskTicket
  } }, this.state.isTicketSubmitting ? t("help.support.sending") : t("help.support.send"))))));
}
